module Meevo.Plugins.EmployeeTemplates {
  "use strict";

  /**
  * Main Section of Employee Template
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplate> {

    /**
      * Base class override which defines what a DEFAULT model looks like.
      */
    createSectionModelInstance(postAdd:(data:any)=>any): void {
      this.dataService.getTemplate(this.baseEndpoint).then((data) => {
        this.model = data;
      });
    }

    activate(): void {
      // Initialize model properties
      this.model.employeeCategoryDetail = undefined
      super.activate();
    }

    get isCategoryRequired(): boolean {
      return this.model !== undefined
        && this.model !== null
        && this.model.employeeCategories !== undefined
        && this.model.employeeCategories !== null
        && this.model.employeeCategories.length === 0;
    }

    addEmployeeCategotry(): void {
      if (this.model.employeeCategoryDetail !== undefined
        && _.find(this.model.employeeCategories, (ec) =>
        { return ec.displayName === this.model.employeeCategoryDetail.displayName }) === undefined) {
        {
          this.model.employeeCategories.push(this.model.employeeCategoryDetail);
          this.model.employeeCategoryDetail = undefined;
        }
      }
    }

    removeEmployeeCategory(index: number): void {
      this.model.employeeCategories.splice(index, 1);
    }
   
  }

}